<div class="overlay-container" #overlayContainer (mouseenter)="showOverlay('hover')"
  (mouseleave)="closeOverlay('hover')">
  <input type="text" class="hidden-input" (focus)="showOverlay('focus')">

  <div class="overlay-item pointer" (click)="showOverlay('click',$event);">
    <ng-container *ngTemplateOutlet="itemTemplate; context: { open: showOverlay }">
    </ng-container>

    <span *ngIf="showArrow" class="dropdown-menu-arrow" [hidden]="!isOverlayVisible" [ngClass]="{
      'arrow-white': arrowColor === 'white', 'arrow-black' : arrowColor === 'black' }"
      [ngStyle]="{ top: arrowTop, right: arrowRight }"></span>
  </div>

  <div id="{{id}}" class="overlay-cotent" [ngStyle]="{ top: top, right: right }" [ngClass]="{
    'display-block': isOverlayVisible,
    'display-none': !isOverlayVisible,
    'dropshadow': dropshadow
    }">
    <ng-container
      *ngTemplateOutlet="overlayTemplate; context: { close: closeOverlay, isOverlayVisible: isOverlayVisible, showOverlay: showOverlay }">
    </ng-container>
  </div>
</div>
